<template>
  <div class="c-sortable-list">
    <draggable @start="dragging = true" @end="dragging = false" v-model="localVal" :disabled="!enabled">
      <slot></slot>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  name: "SortableList",
  props: {
    value: {
      type: [Array,Object,String],
      default: null
    },
    enabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dragging: false
    };
  },
  computed: {
    localVal: {
      get() {
        return this.value
      },
      set(newVal,oldVal) {
        this.$emit('input',newVal)
      }
    }
  },
  components: {
    draggable
  }
};
</script>

<style lang="scss" scoped>
.c-sortable-list {
  border: 2px solid $colour-nhs-med-grey;
  border-radius: 4px;
}
</style>